import { render } from "./PagesPagination.vue?vue&type=template&id=622d4f40&scoped=true"
import script from "./PagesPagination.vue?vue&type=script&lang=js"
export * from "./PagesPagination.vue?vue&type=script&lang=js"

import "./PagesPagination.vue?vue&type=style&index=0&id=622d4f40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622d4f40"]])

export default __exports__